<div class="checkout-shell" *ngIf="isCalculatorVisible">
    <div class="checkout-panel">
        <div class="loading-overlay" *ngIf="isPanelLoading || isLoading">
            <div class="loading-spinner"></div>
        </div>

        <header class="checkout-panel__header">
            <div class="checkout-panel__summary">
                <span class="checkout-panel__eyebrow">Caixa do posto</span>
                <div class="checkout-panel__totals">
                    <div class="checkout-panel__total-card">
                        <span>Total atual</span>
                        <strong>{{ price | currency: 'EUR' }}</strong>
                    </div>

                    <div class="checkout-panel__total-card checkout-panel__total-card--muted">
                        <span>Total registado</span>
                        <strong>{{ totalRegistered | currency: 'EUR' }}</strong>
                    </div>
                </div>

                <div class="checkout-panel__feedback">
                    <span class="checkout-panel__success" *ngIf="showSuccessMessage">Registado com sucesso</span>
                    <span class="checkout-panel__error" *ngIf="showErrorMessage">
                        <mat-icon>error_outline</mat-icon>
                        Erro ao registar
                    </span>
                </div>
            </div>

            <button class="checkout-panel__close" type="button" (click)="close()" aria-label="Fechar caixa">
                <mat-icon>close</mat-icon>
            </button>
        </header>

        <section class="checkout-panel__catalog">
            <div class="checkout-panel__catalog-header">
                <div>
                    <h3>Produtos disponíveis</h3>
                    <p>Seleciona toques para montar o registo atual. O estado de stock continua visível em cada produto.</p>
                </div>
            </div>

            <div class="product-list">
                <button
                    *ngFor="let group of productGroups"
                    type="button"
                    class="product"
                    [ngStyle]="{'background-color': group.backgroundColor, 'color': group.color}"
                    [ngClass]="{
                        'selected': getGroupTouchedTimes(group) > 0,
                        'product--low-stock': isGroupLowStock(group),
                        'product--negative-stock': isGroupNegativeStock(group),
                        'product--multi-variant': !group.isSingle
                    }"
                    (click)="onGroupTileClick(group)">
                    <span class="product-name">{{ group.displayName }}</span>
                    <span class="product-price" *ngIf="group.isSingle">
                        {{ group.products[0].price | currency:'EUR' }}
                    </span>
                    <span class="product-variants-hint" *ngIf="!group.isSingle">
                        {{ group.products.length }} opções
                    </span>
                    <span
                        *ngIf="getGroupStockBadgeText(group)"
                        class="product-stock"
                        [ngClass]="{
                            'product-stock--low': isGroupLowStock(group),
                            'product-stock--negative': isGroupNegativeStock(group)
                        }">
                        {{ getGroupStockBadgeText(group) }}
                    </span>
                    <span *ngIf="getGroupTouchedTimes(group)" class="counter">{{ getGroupTouchedTimes(group) }}</span>
                </button>
            </div>

            <!-- Variant picker for multi-product groups -->
            <div class="variant-picker-overlay" *ngIf="activePicker" (click)="activePicker = null">
                <div class="variant-picker-panel" (click)="$event.stopPropagation()">
                    <div class="variant-picker-panel__title">{{ activePicker.displayName }}</div>
                    <div class="variant-picker-panel__options">
                        <button
                            *ngFor="let product of activePicker.products"
                            type="button"
                            class="variant-picker-option"
                            [ngStyle]="{'background-color': product.backgroundColor || '#13b2c3', 'color': product.color || '#fff'}"
                            [ngClass]="{
                                'selected': product.touchedTimes > 0,
                                'product--low-stock': isLowStock(product),
                                'product--negative-stock': isNegativeStock(product)
                            }"
                            (click)="priceClicked(product.id)">
                            <span class="variant-picker-option__name">{{ getPickerOptionLabel(product) }}</span>
                            <span class="variant-picker-option__price">{{ product.price | currency:'EUR' }}</span>
                            <span *ngIf="showStockBadge(product)" class="product-stock variant-picker-option__stock"
                                [ngClass]="{'product-stock--low': isLowStock(product), 'product-stock--negative': isNegativeStock(product)}">
                                {{ getStockBadgeText(product) }}
                            </span>
                            <span *ngIf="product.touchedTimes" class="counter">{{ product.touchedTimes }}</span>
                        </button>
                    </div>
                    <button class="variant-picker-panel__close" type="button" (click)="activePicker = null">
                        Fechar
                    </button>
                </div>
            </div>
        </section>

        <footer class="checkout-panel__footer">
            <div class="checkout-panel__footer-summary">
                <div class="checkout-panel__footer-total">
                    <span>Total atual</span>
                    <strong>{{ price | currency: 'EUR' }}</strong>
                </div>
                <div class="checkout-panel__footer-registered">
                    Registado: {{ totalRegistered | currency: 'EUR' }}
                </div>
            </div>

            <div class="checkout-panel__footer-meta">
                <span *ngIf="isPartialDeletingCalculator" class="checkout-panel__mode-pill">Modo remover ativo</span>
            </div>

            <div class="action-buttons">
                <button type="button" (click)="resetCalculatingScore()" class="action-btn clear-btn">Limpar</button>
                <button
                    type="button"
                    (click)="partialDeleteCalculator()"
                    class="action-btn partial-delete"
                    [ngClass]="{'focus': isPartialDeletingCalculator}">
                    Remover
                </button>
                <button
                    type="button"
                    (click)="showChangePanel()"
                    class="action-btn troco-btn"
                    [disabled]="price <= 0 || isLoading">
                    Troco
                </button>
                <button
                    type="button"
                    (click)="registerTransaction()"
                    class="action-btn register-btn"
                    [disabled]="price <= 0 || isLoading">
                    <ng-container *ngIf="!isLoading">Registar</ng-container>
                    <ng-container *ngIf="isLoading">
                        <mat-icon class="loading-icon">refresh</mat-icon>
                    </ng-container>
                </button>
            </div>
        </footer>
    </div>
</div>

<div class="checkout-shell checkout-shell--dialog" *ngIf="isChangePanelVisible">
    <div class="change-panel">
        <div class="loading-overlay" *ngIf="isLoading">
            <div class="loading-spinner"></div>
        </div>

        <header class="change-panel__header">
            <button class="change-panel__back" type="button" (click)="goBack()" aria-label="Voltar">
                <mat-icon>arrow_back</mat-icon>
            </button>

            <div class="change-panel__title">
                <span>Troco</span>
                <strong>{{ price | currency:'EUR' }}</strong>
            </div>
        </header>

        <div class="checkout-panel__error checkout-panel__error--block" *ngIf="showErrorMessage">
            <mat-icon>error_outline</mat-icon>
            {{ errorMessage }}
        </div>

        <section class="change-section">
            <div class="field">
                <label>Valor recebido</label>
                <input
                    type="number"
                    [(ngModel)]="amountReceived"
                    (input)="onAmountReceivedChanged(amountReceived)"
                    placeholder="Insira o valor recebido"
                    [value]="amountReceived == null ? '' : amountReceived"/>
            </div>

            <div class="field field--summary">
                <label>Troco</label>
                <div class="troco">
                    {{
                        (amountReceived == null || amountReceived === 0)
                            ? (0 | currency:'EUR')
                            : ((amountReceived - price) | currency:'EUR')
                    }}
                </div>
            </div>
        </section>

        <footer class="action-buttons action-buttons--dialog">
            <button type="button" class="action-btn clear-btn" (click)="goBack()">Voltar</button>
            <button
                type="button"
                (click)="registerTransactionByChange()"
                class="action-btn register-btn"
                [disabled]="price <= 0 || isLoading">
                <ng-container *ngIf="!isLoading">Registar</ng-container>
                <ng-container *ngIf="isLoading">
                    <mat-icon class="loading-icon">refresh</mat-icon>
                </ng-container>
            </button>
        </footer>
    </div>
</div>
